import React, { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import { BrowserRouter } from 'react-router-dom'

import AppRouter from 'AppRouter'

function App() {

  //const currentClinicId = localStorage.getItem('clinic_id')
  
  const [currentClinicId, setCurrentClinicId] = React.useState(
    localStorage.getItem('clinic_id'),
  )

  useEffect(() => {
    const handleClinicIdUpdate = () => {
      setCurrentClinicId(localStorage.getItem('clinic_id'))
    }

    window.addEventListener('clinic-id-changed', handleClinicIdUpdate)
    return () =>
      window.removeEventListener('clinic-id-changed', handleClinicIdUpdate)
  }, [])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return

      const storedClinicId = localStorage.getItem('clinic_id')

      if (storedClinicId !== currentClinicId) {
        window.location.replace(window.location.href)
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () =>
      document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [currentClinicId])

 
  return (
    <div className="app__mainContainer">
      <Toaster position="top-right" reverseOrder={false} />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  )
}

export default App
